<script lang="ts">
    import type { InstallmentPlan } from '@shared/types/types';

    interface Props {
        installmentPlan?: InstallmentPlan;
        showWarning?: boolean;
    }

    let { installmentPlan, showWarning = false }: Props = $props();

    const installmentPrice = $derived.by(() => {
        if (!installmentPlan?.amount) {
            return;
        }
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
        }).format(installmentPlan.amount);
    });
</script>

{#if installmentPlan}
    <span class="oc-copy-75" data-qa="reptile-installments"
        ><span class="oc-copy--bold">{installmentPrice}</span> mtl. in {installmentPlan?.count}
        Raten</span
    >
    {#if showWarning}
        <span class="oc-copy-50 reptile-installments__warning" data-qa="reptile-installment-warning">
            Achtung! Kredite kosten Geld.
        </span>
    {/if}
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-installments {
        &__warning {
            display: block;
            color: tokens.$oc-semantic-color-text-secondary;
        }
    }
</style>
